import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import Skeleton from "../../../components/Skeleton";
import NoResultsFound from "../../../components/NoResultsFound";
import { showToast } from "../../../components/ToastMsg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../components/Pagination";
import DropdownwithValue from "../../../components/DropdownValue";
import BeatLoader from "react-spinners/BeatLoader";
import { downloadPaymentsList, getPayments } from "../../../redux/features/payment/paymentService";
import SearchBar from "../../../components/SearchBar";
import { getActiveCourses } from "../../../redux/features/courses/coursesService";
import { getAllStaffMembers } from "../../../redux/features/staff/staffService";

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const recurringList = [
    { id: '1', name: 'Subscription' },
    { id: '2', name: 'One Time' },
];

const statusList = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Completed' },
];

const Payments = () => {
    const dispatch = useDispatch();
    const statusDropdownRef = useRef(null);
    const coordinatorDropdownRef = useRef(null);
    const courseDropdownRef = useRef(null);

    const { isPaymentsLoading, pageCount, payments } = useSelector(
        (state) => state.payment.payments
    );

    const { isFileDownloading, isFileDownloadSuccess } = useSelector(
        (state) => state.payment.paymentsFile
    );
    const { isCoursesLoading, courses } = useSelector((state) => state.course.activeCourses);

    const { isStaffMembersLoading, staffMembers } = useSelector((state) => state.staff.allStaffMembers);

    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [recurringValue, setRecurringValue] = useState(null);
    const [isRecurring, setRecurring] = useState(false);
    const [statusValue, setStatusValue] = useState(null);
    const [isStatus, setStatus] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedMentor, setselectedMentor] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [skip, setSkip] = useState(1);
    const limit = 25;

    const filterAllPayments = useCallback(
        (filters = {}) => {
            const params = {
                skip: skip,
                limit: limit,
                created_from: dateFrom,
                created_to: dateTo,
                order_status: isStatus && statusValue.name,
                payment_id: searchQuery,
                mentor_id: selectedMentor?.id,

                ...filters,
            };
            dispatch(getPayments(params));
        },
        [dispatch, skip, dateFrom, dateTo, statusValue, searchQuery, selectedMentor]
    );

    useEffect(() => {
        filterAllPayments();
    }, [filterAllPayments]);

    useEffect(() => {
        dispatch(getActiveCourses({}));
        dispatch(getAllStaffMembers({ role_name: "mentor" }));
    }, [dispatch]);

    const formattedCourses = useMemo(() => {
        return courses.map(course => ({
            id: course.id,
            name: course.title
        }));
    }, [courses]);

    const formattedMentors = useMemo(() => {
        return staffMembers.map(staff => ({
            id: staff.id,
            name: staff.full_name
        }));
    }, [staffMembers]);

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber);
    };

    const handleUserSelect = (option) => {
        setselectedMentor(option);
        setSkip(1);
    };

    const handleSelect = (option) => {
        setSelectedCourse(option.id);
        setSkip(1);
    };

    const handleStatus = (option) => {
        setStatus(true);
        setStatusValue(option);
        setSkip(1);
    };

    const clearAll = () => {
        setSkip(1);
        setStatus(false);
        setRecurring(false);
        setSearchQuery('');
        setRecurringValue(null);
        setStatusValue(null);
        setDateFrom();
        setDateTo();
        if (recurringDropdownRef.current) recurringDropdownRef.current.clearSelection();
        if (statusDropdownRef.current) statusDropdownRef.current.clearSelection();
    }

    const downloadFile = async () => {
        try {
            const params = {
                created_from: dateFrom,
                created_to: dateTo,
                is_recurring: isRecurring && recurringValue.name,
                order_status: isStatus && statusValue.name,
            };
            await dispatch(downloadPaymentsList(params)).unwrap();
        } catch (error) {
            showToast("error", error);
        }
    }

    return (
        <>
            <div className={`card-section`}>
                <div className={`search-card`}>
                    <div className={`search-card-header`} style={{ flexDirection: 'column' }}>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <h1 className={`form-title ${styles.headDiv}`}>
                                    Payments List
                                </h1>
                            </div>
                            <div className={`form-input-col ${styles.downloadBtnCol}`}>
                                <button
                                    className={`btn-primary`}
                                    type='button'
                                    disabled={isFileDownloading}
                                    onClick={downloadFile}
                                >
                                    {isFileDownloading ? (
                                        <BeatLoader grade='#ffffff' />
                                    ) : (
                                        `Download Report`
                                    )}
                                </button>
                            </div>
                        </div>
                        <div className={`form-input-row`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Date From
                                    </label>
                                    <input
                                        type="date"
                                        value={dateFrom || ''}
                                        onChange={(e) => { setDateFrom(e.target.value); setSkip(1) }}
                                        className={`form-input-default-small`}
                                        placeholder="Draw Number"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Date To
                                    </label>
                                    <input
                                        type="date"
                                        value={dateTo || ''}
                                        onChange={(e) => { setDateTo(e.target.value); setSkip(1) }}
                                        className={`form-input-default-small`}
                                        placeholder="Draw Number"
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Mentor
                                    </label>
                                    <DropdownwithValue
                                        ref={coordinatorDropdownRef}
                                        options={formattedMentors}
                                        placeholder='Select a Mentor'
                                        onSelect={handleUserSelect}
                                        value={selectedMentor?.name}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-input-row ${styles.searchRow}`}>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label`}>
                                        Payment Status
                                    </label>
                                    <DropdownwithValue
                                        ref={statusDropdownRef}
                                        options={statusList}
                                        placeholder='Select a Status'
                                        onSelect={handleStatus}
                                        value={statusValue?.name}
                                    />
                                </div>
                            </div>
                            <div className={`form-input-col`}>
                                <div className={`form-input-group`}>
                                    <label htmlFor='full_name' className={`form-label ${styles.formLableMobile}`}>
                                        Payment Id
                                    </label>
                                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                                </div>
                            </div>
                            <button
                                className={`btn-primary`}
                                type='button'
                                style={{ height: '38px', marginTop: '25px', padding: '0px 16px' }}
                                onClick={clearAll}>
                                <FontAwesomeIcon icon={faRefresh} />
                            </button>
                        </div>
                    </div>
                    <div className={`search-card-body`}>
                        {isPaymentsLoading ? (
                            <Skeleton
                                columns={["Payment Id", "Customer", "Payment Type", "Status", "Currency", "Amount"]}
                                rowCount={10}
                                height={20}
                            />
                        ) : payments.length > 0 ? (
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Payment Id</th>
                                            <th>Customer</th>
                                            {/* <th>Payment Method</th> */}
                                            <th>Course</th>
                                            <th>Status</th>
                                            <th>Currency</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {payments?.map((payment) => (
                                            <tr key={payment.id}>
                                                <td className={`tdataColumnOne`}>{payment.payment_id}</td>
                                                <td>{payment.order.user.full_name}</td>
                                                {/* <td>{payment.method}</td> */}
                                                <td>{payment?.order?.course?.title}</td>
                                                <td>{payment.order_status}</td>
                                                <td>{payment.currency}</td>
                                                <td>{payment.amount.toFixed(2)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <NoResultsFound />
                        )}
                    </div>
                    <div className={`search-card-footer`}>
                        {pageCount > 0 && (
                            <div className={styles.paginationContainer}>
                                <Pagination
                                    currentPage={skip}
                                    totalPages={pageCount}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div >
        </>
    );
};

export default Payments;